/* eslint-disable no-unused-vars */
export const regionMap = {
  全国: {
    全国: '999999',
  },
  'A-G': {
    安徽: '340000',
    北京: '110000',
    重庆: '500000',
    福建: '350000',
    广东: '440000',
    甘肃: '620000',
    贵州: '520000',
    广西: '450000',
  },
  'H-Q': {
    湖北: '420000',
    湖南: '430000',
    河北: '130000',
    河南: '410000',
    海南: '460000',
    黑龙江: '230000',
    吉林: '220000',
    江西: '360000',
    江苏: '320000',
    辽宁: '210000',
    内蒙古: '150000',
    宁夏: '640000',
    青海: '630000',
  },
  'S-Z': {
    上海: '310000',
    山东: '370000',
    四川: '510000',
    山西: '140000',
    陕西: '610000',
    天津: '120000',
    西藏: '540000',
    新疆: '650000',
    云南: '530000',
    浙江: '330000',
  },
};

export function getAdcodeFromProvince(province = '全国') {
  let adcode = '999999';
  for (const key in regionMap) {
    adcode = regionMap[key][province];
    if (adcode != null) {
      break;
    }
  }
  return adcode;
}
